import type { SVGProps } from "react";

/** A small, consistent stroke icon set (24 px grid, 1.75 stroke). No icon library dependency. */
const PATHS: Record<string, string | string[]> = {
  home: ["M3 10.5 12 3l9 7.5", "M5 9v12h14V9", "M10 21v-6h4v6"],
  chat: ["M21 12a8 8 0 0 1-11.6 7.1L4 20.5l1.4-4.9A8 8 0 1 1 21 12z", "M8.5 12h.01", "M12 12h.01", "M15.5 12h.01"],
  list: ["M8 6h13", "M8 12h13", "M8 18h13", "M3 6h.01", "M3 12h.01", "M3 18h.01"],
  plus: ["M12 5v14", "M5 12h14"],
  quote: ["M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z", "M14 2v6h6", "M8 13h8", "M8 17h5"],
  users: ["M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2", "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8", "M23 21v-2a4 4 0 0 0-3-3.87", "M16 3.13a4 4 0 0 1 0 7.75"],
  flask: ["M9 3h6", "M10 3v6.5L4.6 19a1.5 1.5 0 0 0 1.3 2.2h12.2a1.5 1.5 0 0 0 1.3-2.2L14 9.5V3", "M7.5 15h9"],
  badge: ["M12 2 15 5l4 .5.5 4L22 12l-2.5 2.5-.5 4-4 .5-3 3-3-3-4-.5-.5-4L2 12l2.5-2.5.5-4L9 5z", "m9 12 2 2 4-4"],
  send: ["m22 2-7 20-4-9-9-4z", "M22 2 11 13"],
  cash: ["M2 7h20v10H2z", "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6", "M6 12h.01", "M18 12h.01"],
  stethoscope: ["M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6 6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3", "M8 15v1a6 6 0 0 0 6 6 6 6 0 0 0 6-6v-4", "M20 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"],
  book: ["M4 19.5A2.5 2.5 0 0 1 6.5 17H20", "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"],
  settings: ["M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6", "M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z"],
  search: ["M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16", "m21 21-4.3-4.3"],
  print: ["M6 9V2h12v7", "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2", "M6 14h12v8H6z"],
  tag: ["M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L2 12V2h10l8.6 8.6a2 2 0 0 1 0 2.8", "M7 7h.01"],
  whatsapp: ["M3 21l1.6-4.7A8.5 8.5 0 1 1 7.9 19.5z", "M9 9.5c0 3 2.5 5.5 5.5 5.5l1-1.6-2-.9-.9.9a4 4 0 0 1-2-2l.9-.9-.9-2z"],
  download: ["M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", "m7 10 5 5 5-5", "M12 15V3"],
  scan: ["M3 7V5a2 2 0 0 1 2-2h2", "M17 3h2a2 2 0 0 1 2 2v2", "M21 17v2a2 2 0 0 1-2 2h-2", "M7 21H5a2 2 0 0 1-2-2v-2", "M7 8v8", "M11 8v8", "M15 8v8", "M18 8v8"],
  logout: ["M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", "m16 17 5-5-5-5", "M21 12H9"],
  chevronRight: ["m9 18 6-6-6-6"],
  chevronDown: ["m6 9 6 6 6-6"],
  chevronLeft: ["m15 18-6-6 6-6"],
  x: ["M18 6 6 18", "m6 6 12 12"],
  menu: ["M4 6h16", "M4 12h16", "M4 18h16"],
  check: ["M20 6 9 17l-5-5"],
  warning: ["M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0", "M12 9v4", "M12 17h.01"],
  info: ["M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20", "M12 16v-4", "M12 8h.01"],
  user: ["M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2", "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8"],
  userPlus: ["M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", "M10 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8", "M20 8v6", "M23 11h-6"],
  calendar: ["M3 4h18v18H3z", "M16 2v4", "M8 2v4", "M3 10h18"],
  clock: ["M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20", "M12 6v6l4 2"],
  building: ["M3 21h18", "M5 21V7l8-4v18", "M19 21V11l-6-4", "M9 9v.01", "M9 12v.01", "M9 15v.01", "M9 18v.01"],
  history: ["M3 3v5h5", "M3.05 13A9 9 0 1 0 6 5.3L3 8", "M12 7v5l4 2"],
  eye: ["M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12", "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6"],
  pen: ["M12 20h9", "M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"],
  arrowRight: ["M5 12h14", "m12 5 7 7-7 7"],
  arrowUp: ["M12 19V5", "m5 12 7-7 7 7"],
  arrowDown: ["M12 5v14", "m19 12-7 7-7-7"],
  grip: ["M9 6h.01", "M15 6h.01", "M9 12h.01", "M15 12h.01", "M9 18h.01", "M15 18h.01"],
  trash: ["M3 6h18", "M8 6V4h8v2", "M19 6l-1 14H6L5 6"],
  refresh: ["M21 12a9 9 0 1 1-2.6-6.4", "M21 3v6h-6"],
  dropper: ["M12 2v4", "M9 6h6", "M10 6v4.5L5.5 19a2 2 0 0 0 1.8 3h9.4a2 2 0 0 0 1.8-3L14 10.5V6"],
  doc: ["M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z", "M14 2v6h6"],
  // Text formatting (the Documento editor, ADR 0019).
  bold: ["M7 5h6a3.5 3.5 0 0 1 0 7H7z", "M7 12h7a3.5 3.5 0 0 1 0 7H7z"],
  italic: ["M19 4h-9", "M14 20H5", "M15 4 9 20"],
  underline: ["M6 4v6a6 6 0 0 0 12 0V4", "M4 20h16"],
  alignLeft: ["M3 6h18", "M3 12h12", "M3 18h15"],
  alignCenter: ["M3 6h18", "M6 12h12", "M4.5 18h15"],
  alignRight: ["M3 6h18", "M9 12h12", "M6 18h15"],
  alignJustify: ["M3 6h18", "M3 12h18", "M3 18h18"],
  listOrdered: ["M10 6h11", "M10 12h11", "M10 18h11", "M4 5l1-1v5", "M4 9h2", "M6 19H4l2-2.5a1 1 0 0 0-1.6-1.2"],
  listBullet: ["M9 6h12", "M9 12h12", "M9 18h12", "M4.5 6h.01", "M4.5 12h.01", "M4.5 18h.01"],
  superscript: ["m4 19 8-8", "m12 19-8-8", "M20 10h-4l3.3-3.4a1.6 1.6 0 1 0-2.6-1.8"],
  subscript: ["m4 5 8 8", "m12 5-8 8", "M20 20h-4l3.3-3.4a1.6 1.6 0 1 0-2.6-1.8"],
  microbe: ["M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10", "M12 7V3", "M12 21v-4", "M7 12H3", "M21 12h-4", "M8.5 8.5 6 6", "M18 18l-2.5-2.5", "M15.5 8.5 18 6", "M6 18l2.5-2.5", "M10.5 11h.01", "M13.5 13.5h.01"],
  sun: ["M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10", "M12 1v2", "M12 21v2", "m4.2 4.2 1.4 1.4", "m18.4 18.4 1.4 1.4", "M1 12h2", "M21 12h2", "m4.2 19.8 1.4-1.4", "m18.4 5.6 1.4-1.4"],
  /** A calculated analyte (ADR 0023): the calculator the previous system used, so the lab recognises it. */
  calc: ["M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z", "M8 6h8v4H8z", "M8 14h.01", "M12 14h.01", "M16 14h.01", "M8 18h.01", "M12 18h.01", "M16 18h.01"],
};

export type IconName = keyof typeof PATHS;

export function Icon({ name, ...rest }: { name: IconName } & SVGProps<SVGSVGElement>) {
  const d = PATHS[name];
  const paths = Array.isArray(d) ? d : [d];
  return (
    <svg viewBox="0 0 24 24" width={20} height={20} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...rest}>
      {paths.map((p, i) => (
        <path key={i} d={p} />
      ))}
    </svg>
  );
}

/**
 * The Probeta Lab mark (ADR 0018, docs/design/directions/a-cobalto): a test tube tilted −12°, drawn as
 * glass with the liquid in its lower part, millilitre graduations on the inner wall (the two inside the
 * liquid are holes, so the mark works on any ground) and the cherry dot resting in the round bottom.
 * Glass and liquid take `currentColor`; the dot keeps its own colour. One dot per screen: the mark is
 * the only place it appears.
 */
export function Mark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="6.81 -0.58 35.44 50.15" aria-hidden="true" {...props}>
      <g transform="rotate(-12 24 22)">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M18.5 21.43L29.5 23.77V37.6A5.5 5.5 0 0 1 18.5 37.6ZM27.1 26.4H28.9A0.6 0.6 0 0 1 29.5 27V27.1A0.6 0.6 0 0 1 28.9 27.7H27.1A0.6 0.6 0 0 1 26.5 27.1V27A0.6 0.6 0 0 1 27.1 26.4ZM25.1 30.4H28.9A0.6 0.6 0 0 1 29.5 31V31.1A0.6 0.6 0 0 1 28.9 31.7H25.1A0.6 0.6 0 0 1 24.5 31.1V31A0.6 0.6 0 0 1 25.1 30.4Z"
        />
        <path
          fill="currentColor"
          d="M25.1 10.4H28.9A0.6 0.6 0 0 1 29.5 11V11.1A0.6 0.6 0 0 1 28.9 11.7H25.1A0.6 0.6 0 0 1 24.5 11.1V11A0.6 0.6 0 0 1 25.1 10.4ZM27.1 14.4H28.9A0.6 0.6 0 0 1 29.5 15V15.1A0.6 0.6 0 0 1 28.9 15.7H27.1A0.6 0.6 0 0 1 26.5 15.1V15A0.6 0.6 0 0 1 27.1 14.4ZM25.1 18.4H28.9A0.6 0.6 0 0 1 29.5 19V19.1A0.6 0.6 0 0 1 28.9 19.7H25.1A0.6 0.6 0 0 1 24.5 19.1V19A0.6 0.6 0 0 1 25.1 18.4Z"
        />
        <path fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5H34.5M17 4.5V37.6A7 7 0 0 0 31 37.6V4.5" />
        <circle fill="#D83A44" cx="24" cy="38.6" r="3.6" />
      </g>
    </svg>
  );
}
